import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, inject } from '@angular/core';

import { RegionVisibilityService } from '@frontend/sports/betting-offer/feature/region-visibility';
import { FavouritesConfig, GridConfig as GridClientConfig } from '@frontend/sports/common/client-config-data-access';
import { SPORTS_WITHOUT_AVAILABLE_REGION, SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { ColoredIconComponent } from '@frontend/sports/common/ui/colored-icon';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { FavouriteLeagueToggleComponent } from '@frontend/sports/favourites/feature/league-toggle';
import { LeagueGroup } from '@frontend/sports/grid/core/feature/model';
import { includes } from 'lodash-es';

@Component({
    selector: 'ms-league-header',
    templateUrl: './league-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FavouriteLeagueToggleComponent, CompetitionLogoComponent, ColoredIconComponent],
})
export class LeagueHeaderComponent implements OnChanges {
    private regionVisibilityService = inject(RegionVisibilityService);
    private gridClientConfig = inject(GridClientConfig);
    private favouritesConfig = inject(FavouritesConfig);

    @Input() league: LeagueGroup;
    @Input() sportId: number;
    @Input() hideFavourites = false;
    @Input() hideHeaderRegion = false;

    @Input() set competitionFallbackIcon(value: string | undefined) {
        this.fallbackIcon = value || 'sports-league';
    }

    @HostBinding('class') className = 'league-group';

    fallbackIcon: string;
    showCompetitionLogo = false;
    showPipeSeparator = this.gridClientConfig.gridEventDisplayVersion !== 'V2';

    ngOnChanges(): void {
        if (this.hideHeaderRegion) {
            this.showCompetitionLogo = true;
        }
    }

    get showFavouriteToggle(): boolean {
        return this.league.canBeFavourited && !this.hideFavourites && this.favouritesConfig.isFavouritesEnabled;
    }

    get title(): string {
        if (this.hideHeaderRegion) {
            return this.league.name;
        }
        const hidePrefix = includes(SPORTS_WITHOUT_AVAILABLE_REGION, this.sportId);

        if (hidePrefix) {
            return this.league.name;
        } else {
            const region = this.league.region.name;

            const leagueName = this.showPipeSeparator ? `${region} | ${this.league.name}` : `${region} • ${this.league.name}`;

            return this.regionVisibilityService.shouldHide(this.league.region, this.league) ? this.league.name : leagueName;
        }
    }

    get isTournament(): boolean {
        return this.sportId === SportConstant.Tennis;
    }
}
